exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-b3d8c490]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-b3d8c490&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/offers/list-offers.vue
// module id = 370
// module chunks = 0